<template>
  <v-card>
    <v-card-title class="justify-end pa-1">
      <v-btn icon @click="$emit('close-form')">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <h2 class="black--text pb-3">Pilih Print Dokumen</h2>
      <v-col>
        <v-btn
          color="primary"
          tile
          elevation="0"
          class="white--text text-none"
          width="267"
          @click="printPatientCard"
          >Kartu Pasien</v-btn
        >
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          tile
          elevation="0"
          class="white--text text-none"
          width="267"
          @click="printQueue"
          >{{ onState()?.textQueue }}</v-btn
        >
      </v-col>
      <v-col>
        <v-btn
          :color="hasGeneralConsent ? '#f5f5f5' : 'primary'"
          tile
          elevation="0"
          class="white--text text-none"
          :class="{ 'green--text': hasGeneralConsent }"
          width="267"
          @click="
            changeForm(0);
            state === 'rawat-jalan' ? $emit('close-form') : () => {};
          "
          >{{ onState()?.textGeneralConsent }}</v-btn
        >
        <v-dialog width="1700" v-model="dialogConsent">
          <general-consent-form
            v-if="dialogConsent && selectedForm === 0"
            @close-form="dialogConsent = false"
            service-type="Rawat Jalan"
            :rm-number="socialData.rmNumber"
          />
        </v-dialog>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import GeneralConsentForm from './GeneralConsentForm.vue';
import JsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';
import Canvas from 'canvas';
import moment from 'moment-timezone';
import printMixin from '@/mixin/printMixin';
import Constant from '@/const';
const axios = require('axios');
// import QRCode from 'qrcodejs2';

export default {
  name: 'PrintDialog',
  components: {
    GeneralConsentForm,
  },
  mixins: [printMixin],
  props: {
    selectedPatient: Object,
    hasGeneralConsent: Boolean,
    state: String,
    openFromRegistRJ: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printData: null,
      dialogConsent: false,
      selectedForm: '',
      socialData: {}, // social data for general consent props
    };
  },
  mounted() {
    this.socialData = {
      name: this.openFromRegistRJ
        ? this.selectedPatient.meta.display_name
        : this.selectedPatient.meta.name,
      address: this.selectedPatient.meta.address,
      telp: this.selectedPatient.meta.phoneNumber,
      identityNumber: this.selectedPatient.meta.identityNumber,
      age: this.selectedPatient.meta.age,
      gender:
        this.selectedPatient.meta.gender !== 'Perempuan' ||
        this.selectedPatient.meta.gender === true,
      rmNumber: this.selectedPatient.rmNumber,
      birthDate: this.selectedPatient.meta.birthDate,
    };
    this.getRegistrationById();
  },
  methods: {
    async getRegistrationById() {
      if (!this?.selectedPatient?.id_registration) return;

      try {
        const response = await axios.get(
          Constant.apiUrl.concat(
            `/patient/registration/${this.selectedPatient.id_registration}`,
          ),
        );
        if (response.status === 200) {
          const { data } = response.data;
          this.printData = {
            name: data.medical_record.display_name,
            address: this.socialData.address, // complete addresses
            telp: data.medical_record.phone_number,
            identityNumber: data.identity?.number,
            age: data.medical_record.age,
            gender:
              data.medical_record.gender !== 'Perempuan' ||
              data.medical_record.gender === true,
            rmNumber: data.medical_record.medical_record_number,
            birthDate: data.medical_record.birth.date,
          };
        }
      } catch {
        return;
      }
    },
    onState() {
      switch (this.state) {
        case 'rawat-jalan': {
          return {
            textQueue: 'Antrean Rawat Jalan',
            idEmr: this.selectedPatient.id_emr,
            textGeneralConsent: `General Consent ${
              this.hasGeneralConsent ? 'Sudah Diproses' : 'Rawat Jalan'
            }`,
            polyName: this.selectedPatient.meta.poly[0],
          };
        }
        case 'laboratorium': {
          return {
            textQueue: 'Antrean Laboratorium',
            idEmr: this.selectedPatient.idEMR,
            textGeneralConsent: `General Consent ${
              this.hasGeneralConsent ? 'Sudah Diproses' : 'Laboratorium'
            }`,
            polyName: this.selectedPatient.meta.polyName,
          };
        }
      }
    },
    changeForm(value) {
      this.selectedForm = value;
      this.dialogConsent = true;
    },
    printPatientCard() {
      const dataPrint = this.printData ? this.printData : this.socialData;

      const doc = new JsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: [30, 70],
      });
      const marginX = 3;
      const marginTop = 5;
      let currentY = marginTop;

      // RM Number at top
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text(`${dataPrint.rmNumber}`, marginX, currentY);
      currentY += 4;

      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text(`${dataPrint.name}`, marginX, currentY);
      currentY += 3.5;

      // Birth date, age, and gender
      const gender = dataPrint.gender === 'Perempuan' ? 'P' : 'L';

      const birthDateMoment = moment(dataPrint.birthDate);
      const birthDateValid = birthDateMoment.isValid();
      const birthDate = birthDateValid
        ? birthDateMoment.format('DD/MM/YYYY')
        : dataPrint.birthDate;

      doc.setFontSize(6);
      doc.setFont('helvetica', 'normal');
      doc.text(
        `Tgl Lahir: ${birthDate} (${dataPrint.age} Thn) | ${gender}`,
        marginX,
        currentY,
      );
      currentY += 3;

      // Address
      let address = dataPrint.address || '';
      address = address.toUpperCase();
      const maxWidth = 64;
      doc.setFontSize(6);

      // Truncate address if too long
      while (doc.getTextWidth(address) > maxWidth && address.length > 0) {
        address = address.substring(0, address.length - 1);
      }
      if (address.length < (dataPrint.address || '').length) {
        address = address.substring(0, address.length - 3) + '...';
      }

      doc.text(address, marginX, currentY);
      currentY += 3;

      // Barcode
      const transformRm = Canvas.createCanvas();
      JsBarcode(transformRm, `${dataPrint.rmNumber}`, {
        height: 20,
        font: 'times',
        width: 1.3,
        margin: 1,
        displayValue: false,
        fontOptions: 'bold',
        fontSize: 8,
      });
      const jpegUrl = transformRm.toDataURL('image/jpeg');
      doc.addImage(jpegUrl, 'JPEG', marginX, currentY, 30, 8);

      this.printDocument(doc, {
        docName: 'Kartu Pasien',
        rmNumber: dataPrint.rmNumber,
      });
    },
    printQueue() {
      const doc = new JsPDF({
        orientation: 'potrait',
        unit: 'cm',
        format: [6.5, 8],
      });
      // const marginX = 2;

      const perLine = doc.getTextDimensions(' ').h;
      const addLine = line => perLine * line + 0.4;

      const alignCenter = (text, addingLine, y, x = 0) => {
        doc.text(
          text,
          doc.internal.pageSize.getWidth() / 2 -
            doc.getTextDimensions(text).w / 2 +
            x,
          y || addLine(addingLine),
          { align: 'left', charSpace: 0 },
        );
      };

      doc.setFontSize(11);
      doc.setFont('Helvetica', 'normal');
      alignCenter(
        `${this.$store.getters.userLoggedIn.clinic.altName}`,
        undefined,
        addLine(1),
      );
      doc.setLineWidth(0.01);
      doc.line(1, 1.2, 5.6, 1.2);

      doc.setFontSize(this.selectedPatient.meta.doctor === '' ? 18 : 11);
      doc.setFont('helvetica', 'bold');
      alignCenter(
        `${this.onState()?.polyName}`,
        undefined,
        addLine(this.selectedPatient.meta.doctor === '' ? 2.6 : 2.3),
      );
      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      alignCenter(
        `${this.selectedPatient.meta.doctor}`,
        undefined,
        addLine(3.1),
      );
      doc.setFontSize(25);
      doc.setFont('helvetica', 'bold');
      alignCenter(this.selectedPatient.queue, undefined, addLine(4.7));

      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      alignCenter(`${this.selectedPatient.meta.name}`, undefined, addLine(5.5));
      alignCenter(
        `RM. ${this.selectedPatient.rmNumber} (${this.selectedPatient.meta.age} tahun)`,
        undefined,
        addLine(6.4),
      );
      doc.setFontSize(13);
      doc.setFont('helvetica', 'bold');
      alignCenter(
        `${this.selectedPatient.guarantorType?.toUpperCase()}`,
        undefined,
        addLine(7.5),
      );
      const transformRm = Canvas.createCanvas();
      JsBarcode(transformRm, this.selectedPatient.noRegist, {
        height: 30,
        font: 'times',
        width: 1.2,
        margin: 1,
        displayValue: false,
        fontOptions: 'bold',
        fontSize: 9,
      });
      const jpegUrl = transformRm.toDataURL('image/jpeg');
      doc.addImage(jpegUrl, 'JPEG', 1.4, 4.9);
      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      alignCenter(
        `Dicetak ${moment(new Date())
          .locale('id')
          .format('DD-MM-YYYY')} ${moment(new Date())
          .locale('id')
          .format('LT')} WIB`,
        undefined,
        addLine(11),
      );
      this.printDocument(doc, {
        docName:
          this.state === 'rawat-jalan'
            ? 'Kartu Antrean Rawat Jalan'
            : 'Kartu Antrean Laboratorium',
        rmNumber: this.selectedPatient.rmNumber,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
